(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-now"] && !Shopify.designMode) return;
  try {
    class BuyNowButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-buy-now-submit]');
      this.errorEl = this.querySelector('[data-buy-now-error]');
      this.actionType = this.dataset.actionType;
      this.isSubmitting = false;

      if (this.actionType === 'cart') {
        this.hasBundleSelector = Boolean(document.querySelector('bundle-selector'));
        this.items = this.button
          ? [{ id: Number(this.button.dataset.variantId), quantity: 1 }]
          : [];
        this.available = Boolean(this.button) && !this.button.disabled;

        document.addEventListener('variant:change', (event) => this.onVariantChange(event.detail));
        document.addEventListener('bundle:change', (event) => this.onBundleChange(event.detail));
      }

      if (this.button) {
        this.button.addEventListener('click', () => this.onClick());
      }
    }

    onClick() {
      if (this.actionType === 'cart') {
        this.addToCart();
        return;
      }

      switch (this.dataset.customAction) {
        case 'scroll_top':
          window.scrollTo({ top: 0, behavior: 'smooth' });
          break;
        case 'scroll_bottom':
          window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
          break;
        case 'cart':
          window.location.href = this.dataset.cartUrl;
          break;
        case 'checkout':
          window.location.href = this.dataset.checkoutUrl;
          break;
        case 'anchor': {
          const target = document.getElementById(this.dataset.anchorTarget);
          if (target) target.scrollIntoView({ behavior: 'smooth' });
          break;
        }
        case 'url':
        default:
          if (this.dataset.url) {
            const url = new URL(this.dataset.url, window.location.href);
            if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash.startsWith('#popup-')) {
              const request = new CustomEvent('tended:popup-open', {
                cancelable: true,
                detail: { id: url.hash.slice(1), opener: this.button },
              });
              if (!document.dispatchEvent(request)) break;
            }
            window.location.href = this.dataset.url;
          }
          break;
      }
    }

    onVariantChange(detail) {
      if (this.hasBundleSelector) return;

      if (detail.variantId) {
        this.items = [{ id: detail.variantId, quantity: 1 }];
      }
      this.setAvailable(Boolean(detail.variantId) && Boolean(detail.available));
    }

    onBundleChange(detail) {
      this.items = detail.items || [];
      this.setAvailable(Boolean(detail.available) && this.items.length > 0);
    }

    setAvailable(available) {
      this.available = available;
      if (this.button) {
        this.button.disabled = !available;
        this.button.textContent = available
          ? this.dataset.availableLabel
          : this.dataset.soldOutLabel;
      }
    }

    async addToCart() {
      if (!this.available || !this.items.length || this.isSubmitting || !this.button) return;

      this.isSubmitting = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.addingLabel || this.dataset.availableLabel;
      if (this.errorEl) this.errorEl.hidden = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: this.items }),
        });

        if (!response.ok) {
          const body = await response.json().catch(() => null);
          throw new Error((body && body.description) || this.dataset.errorLabel);
        }

        await this.refreshCartCount();
        document.querySelector('cart-drawer')?.open();

        this.isSubmitting = false;
        this.button.disabled = false;
        this.button.textContent = this.dataset.availableLabel;
      } catch (error) {
        this.isSubmitting = false;
        this.button.disabled = false;
        this.button.textContent = this.dataset.availableLabel;
        if (this.errorEl) {
          this.errorEl.textContent = error.message || this.dataset.errorLabel;
          this.errorEl.hidden = false;
        }
      }
    }

    // The page no longer navigates to /cart on a successful add, so the
    // header cart-count badge has to be refreshed client-side instead.
    // Creates the badge element if the cart was previously empty (Liquid
    // only renders it when cart.item_count > 0, so a first-ever
    // add-to-cart has no existing badge to update).
    async refreshCartCount() {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`);
      const cart = await response.json();
      const cartLink = document.querySelector('.site-header__cart');
      let badge = document.querySelector('.site-header__cart-count');

      if (cart.item_count > 0) {
        if (!badge && cartLink) {
          badge = document.createElement('span');
          badge.className = 'site-header__cart-count';
          cartLink.prepend(badge);
        }
        if (badge) badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    }
  }

  if (!customElements.get('buy-now-button')) {
    customElements.define('buy-now-button', BuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-contents"] && !Shopify.designMode) return;
  try {
    class CartItems extends HTMLElement {
    connectedCallback() {
      // Serializes every cart mutation from THIS instance through one
      // chain - see changeLine() below for the real bug this fixes:
      // removing multiple lines in quick succession fired overlapping
      // /cart/change.js requests with nothing preventing them from
      // racing each other server-side.
      this.pendingChange = Promise.resolve();

      this.addEventListener('click', (event) => {
        const decreaseBtn = event.target.closest('[data-quantity-decrease]');
        const increaseBtn = event.target.closest('[data-quantity-increase]');
        const removeBtn = event.target.closest('[data-cart-remove]');

        if (decreaseBtn) this.step(decreaseBtn, -1);
        if (increaseBtn) this.step(increaseBtn, 1);
        if (removeBtn) this.changeLine(removeBtn.closest('[data-cart-item]'), 0);
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-quantity-input]');
        if (!input) return;
        const quantity = Math.max(0, parseInt(input.value, 10) || 0);
        this.changeLine(input.closest('[data-cart-item]'), quantity);
      });
    }

    step(button, delta) {
      const row = button.closest('[data-cart-item]');
      const input = row.querySelector('[data-quantity-input]');
      const quantity = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      input.value = quantity;
      this.changeLine(row, quantity);
    }

    // Real bug fixed here: removing item A then immediately item B (two
    // DIFFERENT rows) used to fire two independent, overlapping
    // /cart/change.js requests with nothing serializing them.
    // Shopify's cart endpoint doesn't guarantee safe concurrent
    // mutation of the same cart - confirmed two distinct failure modes
    // from that race: (1) a request targeting a line `key` that the
    // OTHER concurrent request had already invalidated came back as an
    // error-shaped response with no total_price/original_total_price at
    // all, which render() then blindly formatted as literal "NaN"
    // prices; (2) a genuine server-side lost update, where one of the
    // two removals didn't actually stick - explaining previously-
    // removed items silently reappearing the next time the drawer
    // reopened and re-synced against the real (still-not-empty) cart.
    //
    // Fixed by routing every mutation from this instance through one
    // chained queue (this.pendingChange, set up in connectedCallback())
    // - never more than one /cart/change.js in flight at a time,
    // regardless of which row triggered it. The affected row stays
    // visually "is-updating" for its whole time in the queue, not just
    // during its own network call, which is the correct UX for "this is
    // still pending" either way.
    //
    // A SEPARATE real bug fixed here too: a second interaction on the
    // SAME row while its own request is still in flight (e.g. double/
    // triple-clicking the +/- stepper, a common impatient-click pattern)
    // used to just hit the is-updating guard below and be silently
    // dropped - step() had already optimistically written the new value
    // into the input, but no request was ever sent for it, so the next
    // render() overwrote the input back to the FIRST request's quantity
    // with no explanation. Looked exactly like "sometimes prices don't
    // update" - intermittent, only reproducible when the second click
    // lands inside the first request's round-trip window. Fixed by
    // remembering the latest requested quantity on the row instead of
    // dropping it, and firing it as an automatic follow-up once the
    // in-flight request for that row resolves - rapid repeated clicks
    // coalesce into one follow-up for the final desired quantity rather
    // than one request per click.
    changeLine(row, quantity) {
      if (!row) return;

      if (row.classList.contains('is-updating')) {
        row.dataset.pendingQuantity = quantity;
        return;
      }

      row.classList.add('is-updating');
      this.sendChange(row, quantity);
    }

    sendChange(row, quantity) {
      this.pendingChange = this.pendingChange.then(() => {
        // Computed now that it's actually this request's turn, not back
        // when the click happened - any earlier queued removals have
        // already run render() and shifted everyone else's position by
        // now, so capturing this eagerly at click time (the previous
        // approach) could target the wrong line once a queue exists.
        const rowIndex = Array.from(this.querySelectorAll('[data-cart-item]')).indexOf(row);

        return fetch(`${window.Shopify?.routes?.root ?? '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: row.dataset.key, quantity,
            ...(this.dataset.sectionId ? {
              sections: [this.dataset.sectionId], sections_url: window.location.pathname,
            } : {}),
          }),
        })
          .then((res) => {
            if (!res.ok) throw new Error(`cart/change.js failed: ${res.status}`);
            return res.json();
          })
          .then((cart) => {
            this.render(cart, row, rowIndex, quantity);

            // A newer quantity was requested while this one was in
            // flight (see the doc comment above changeLine()) - fire it
            // now rather than leaving it dropped. row.isConnected is
            // false when this was a removal (render() took the row out
            // of the DOM entirely), which correctly makes any pending
            // quantity for it moot.
            if (row.isConnected && row.dataset.pendingQuantity !== undefined) {
              const nextQuantity = Number(row.dataset.pendingQuantity);
              delete row.dataset.pendingQuantity;
              row.classList.add('is-updating');
              this.sendChange(row, nextQuantity);
            }
          })
          .catch(() => {
            row.classList.remove('is-updating');
            delete row.dataset.pendingQuantity;
            // An error response (or any other failure) means our local
            // view of the cart may now be stale or wrong - resync from
            // Shopify's real current cart state rather than risk leaving
            // a broken or inconsistent display up.
            this.hardRefresh();
          });
      });
    }

    // Re-fetches this section's own fresh server-rendered HTML (the
    // drawer's own refresh(), same technique it already uses on open) so
    // a failed/raced mutation can't leave a stale or corrupted view -
    // falls back to Shopify's real current cart state instead of trying
    // to keep patching a client-side model that may have drifted. Not
    // every page has a cart-drawer instance (the plain /cart page
    // doesn't) - a full reload is the only way to guarantee a correct
    // resync there.
    hardRefresh() {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.refresh === 'function') {
        drawer.refresh();
      } else {
        window.location.reload();
      }
    }

    // requestedQuantity/changedRowIndex fix a real bug: Shopify's cart
    // line `key` is NOT stable across a quantity change that crosses an
    // automatic-discount threshold - e.g. this store's "2 Pairs" bundle
    // discount is present at quantity 2 and gone at quantity 1, and the
    // line's key hash changes as a side effect (confirmed directly
    // against a live /cart/change.js response: same variant, same empty
    // properties, but a completely different key string). Matching the
    // response by the OLD key (the previous approach) found nothing and
    // wrongly deleted the row on a plain 2->1 decrement, even though the
    // line was genuinely still there under a new key.
    //
    // Fixed two ways together: requestedQuantity is 0 only when WE
    // explicitly asked for removal (the remove button, or the stepper
    // reaching 0) - not inferred from a failed lookup - so a real
    // decrement to a positive quantity never gets treated as a deletion
    // just because the key moved. And changedRowIndex finds the same
    // line by its stable POSITION in the cart instead of its key, which
    // is safe here because a positive-quantity update to one line never
    // reorders or removes any other line.
    //
    // The same key drift can also hit OTHER, untouched lines as a side
    // effect of this change (e.g. removing one variant can drop the whole
    // product below the discount threshold, changing a SIBLING line's key)
    // - see the full-row resync loop below, which re-keys every row by
    // position on every render(), not just the one that was acted on.
    render(cart, changedRow, changedRowIndex, requestedQuantity) {
      const cartCount = document.querySelector('.site-header__cart-count');

      if (cart.item_count === 0) {
        // Swap to the empty state in place rather than a full page reload -
        // reloading would be jarring if this instance lives inside the cart
        // drawer (loses the open drawer entirely instead of just showing it
        // empty). Data attributes carry the already-translated strings so
        // this doesn't have to hardcode English or duplicate the Liquid
        // empty-state markup's translation logic.
        const empty = document.createElement('div');
        empty.className = 'cart-page__empty';
        empty.innerHTML = `
          <span class="cart-page__empty-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686" />
            </svg>
          </span>
          <p class="cart-page__empty-message"></p>
          <a class="cart-page__continue-link"></a>
        `;
        empty.querySelector('.cart-page__empty-message').textContent = this.dataset.emptyMessage;
        const link = empty.querySelector('.cart-page__continue-link');
        link.href = this.dataset.continueUrl;
        link.textContent = this.dataset.continueLabel;
        this.replaceWith(empty);

        if (cartCount) cartCount.remove();
        return;
      }

      if (requestedQuantity === 0) {
        changedRow.remove();
      } else if (!cart.items[changedRowIndex]) {
        // Genuinely unexpected (the index should always resolve for a
        // non-zero requested quantity) - remove rather than leave a
        // stale/wrong row silently stuck mid-update.
        changedRow.remove();
      } else {
        changedRow.classList.remove('is-updating');
      }

      // A mutation to ANY line can shift ANOTHER line's key/price as a
      // side effect, not just the one that was directly changed - e.g.
      // removing one variant of this product can drop the whole product
      // below an automatic-discount quantity threshold ("2 Pairs"),
      // changing the surviving variant's line key too. Confirmed live: a
      // properly-queued, non-overlapping second removal still got a
      // genuine 400 from Shopify because the key captured at its last
      // render had gone stale this way (the request above only kept the
      // row it directly touched in sync). Re-syncing every remaining row
      // against the fresh cart.items by position on every render() call -
      // not just the row that was directly acted on - keeps every row's
      // key/price correct no matter which line actually changed.
      const sectionHTML = cart.sections?.[this.dataset.sectionId];
      const freshRows = typeof sectionHTML === 'string'
        ? Array.from(new DOMParser().parseFromString(sectionHTML, 'text/html').querySelectorAll('[data-cart-item]'))
        : [];
      const rows = Array.from(this.querySelectorAll('[data-cart-item]'));
      rows.forEach((row, index) => {
        const item = cart.items[index];
        if (!item) return;

        this.syncDescription(row, freshRows[index]);
        row.dataset.key = item.key;
        row.querySelector('[data-line-price]').textContent = this.formatMoney(item.final_line_price);
        row.querySelector('[data-quantity-input]').value = item.quantity;

        // Compare-price/savings-badge are always present in the DOM (see
        // this file's doc comment) - a change can cross the discount
        // threshold in either direction, so both toggle hidden + text
        // here rather than assuming their prior state.
        const hasDiscount = item.original_line_price > item.final_line_price;
        const comparePriceEl = row.querySelector('[data-line-compare-price]');
        if (comparePriceEl) {
          comparePriceEl.hidden = !hasDiscount;
          comparePriceEl.textContent = this.formatMoney(item.original_line_price);
        }
        const savingsBadgeEl = row.querySelector('[data-line-savings-badge]');
        if (savingsBadgeEl) {
          savingsBadgeEl.hidden = !hasDiscount;
          savingsBadgeEl.textContent = this.formatSavings(item.original_line_price - item.final_line_price);
        }
      });

      // The pulse animation (.is-updated) is triggered on drawer open, not
      // on every change here - see sections/cart-drawer.liquid's open().
      const subtotal = this.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = this.formatMoney(cart.original_total_price);

      const discountsRow = this.querySelector('[data-cart-discounts-row]');
      if (discountsRow) discountsRow.hidden = !(cart.total_discount > 0);
      const discounts = this.querySelector('[data-cart-discounts]');
      if (discounts) discounts.textContent = `−${this.formatMoney(cart.total_discount)}`;

      const total = this.querySelector('[data-cart-total]');
      if (total) total.textContent = this.formatMoney(cart.total_price);

      if (cartCount) cartCount.textContent = cart.item_count;
    }

    syncDescription(row, freshRow) {
      const description = row.querySelector('[data-cart-item-description]');
      if (!description) return;
      const fresh = freshRow?.querySelector('[data-cart-item-description]');
      if (fresh) {
        description.replaceChildren(...Array.from(fresh.childNodes));
        description.hidden = fresh.hidden;
      } else {
        // A section can render as null even after a successful mutation.
        // Hide native counts until the next refresh rather than show stale ones.
        const components = description.querySelector('[data-bundle-components]');
        if (components) components.hidden = true;
      }
    }

    // Substitutes into the REAL translated template (data-you-saved-template
    // above) rather than a hardcoded English string - same reasoning as
    // formatMoney()'s money_format handling, so a non-English store's
    // savings badge stays correctly translated even after a JS-driven
    // update, not just on first server-render. __AMOUNT__ matches the
    // plain-text marker the Liquid side actually renders - see that
    // attribute's own comment for why it isn't a double-brace token.
    formatSavings(cents) {
      const template = this.dataset.youSavedTemplate || 'You saved __AMOUNT__';
      return template.replace('__AMOUNT__', this.formatMoney(cents));
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        // Intl's default 'symbol' display prefixes region-disambiguated
        // currencies with their country code (e.g. MXN -> "MX$"), not
        // requested/wanted here - 'narrowSymbol' gives the plain "$" this
        // theme wants while leaving unambiguous currencies (USD, GBP, ...)
        // unaffected, confirmed via direct comparison of both modes.
        currencyDisplay: 'narrowSymbol',
      });
    }
  }

  if (!customElements.get('cart-items')) {
    customElements.define('cart-items', CartItems);
  }
  } catch(e) { console.error(e); }
})();

})();
